"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toArray = toArray;

function toArray(obj) {
    var ret = [];
    for (var attr in obj) {
        ret[attr] = obj;
    }

    return ret;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/reactable/lib/reactable/lib/to_array.js
// module id = 1169
// module chunks = 0